import { useLocalization } from "@fluent/react";
import { default as ByzantineAddress } from "byzantine/src/Address";
import { Control, FieldPath, FieldValues, Path } from "react-hook-form";
import { AddressAutocompleteInput } from "@lending/components/AddressAutocompleteInput/AddressAutocompleteInput";
import { Select } from "@lending/components/Select/Select";
import { TextInput } from "@lending/components/TextInput/TextInput";
import styles from "./AddressInput.module.css";
import { STATES } from "./states";

interface AddressProps<T extends FieldValues> {
  control: Control<T, unknown>;
  name: Path<T>;
  isBreakpoint: boolean;
  onUpdate: (address: ByzantineAddress) => void;
}

function AddressInput<T extends FieldValues>(props: AddressProps<T>) {
  const { l10n } = useLocalization();

  const isAutocompleteApiAvailable = !!window.google?.maps;

  return (
    <div className={styles.formContent}>
      {isAutocompleteApiAvailable ? (
        <AddressAutocompleteInput
          name={`${props.name}.street_address` as FieldPath<T>}
          control={props.control}
          label={l10n.getString("address-input-street-address", null, "Street address")}
          onUpdate={props.onUpdate}
        />
      ) : (
        <TextInput
          name={`${props.name}.street_address` as FieldPath<T>}
          control={props.control}
          label={l10n.getString("address-input-street-address", null, "Street address")}
        />
      )}
      <TextInput
        name={`${props.name}.street_address_2` as FieldPath<T>}
        control={props.control}
        label={l10n.getString("address-input-street-address-2", null, "Apt/Suite")}
      />
      <TextInput
        name={`${props.name}.city` as FieldPath<T>}
        control={props.control}
        label={l10n.getString("address-input-city", null, "City")}
      />
      <Select
        name={`${props.name}.region_code` as FieldPath<T>}
        control={props.control}
        label={l10n.getString("address-input-state", null, "State")}
        items={STATES}
      />
      <TextInput
        name={`${props.name}.postal_code` as FieldPath<T>}
        control={props.control}
        label={l10n.getString("address-input-zip-code", null, "ZIP code")}
      />
    </div>
  );
}

export { AddressInput };
